module.exports = __webpack_public_path__ + "static/media/kc.d46a4846.png";